// A level and a column of the product's cost matrix are the same thing, so these are the ones it prices.
export const SENIORITY_LEVELS = ['intern', 'student', 'junior', 'middle', 'senior'] as const;
export type Seniority = (typeof SENIORITY_LEVELS)[number];

// The ladder used to read junior/medior/senior/lead; lead has no row to price, so it reads as unset.
const RENAMED: Record<string, string> = { medior: 'middle' };
export const normaliseSeniority = (stored: string): string => {
  const level = RENAMED[stored] ?? stored;
  return (SENIORITY_LEVELS as readonly string[]).includes(level) ? level : '';
};
